<div id="acc-root" class="acc-overlay" (click)="onClose()">
  <section
    class="acc-card ec-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ec-title"
    (click)="$event.stopPropagation()"
  >
    <h2 id="ec-title">{{ 'componentsWizard.estabCreate.title' | translate }}</h2>
    <p class="ec-subtitle">{{ 'componentsWizard.estabCreate.subtitle' | translate }}</p>

    <form class="acc-form ec-form" [formGroup]="form" (ngSubmit)="submit()">
      <!-- Nom -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.estabCreate.nameLabel' | translate }}</label>
        <input class="acc-input ec-input" type="text" formControlName="name" [placeholder]="'componentsWizard.estabCreate.namePlaceholder' | translate" />
      </div>

      <!-- Adresse -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.estabCreate.addressLabel' | translate }}</label>
        <textarea class="acc-input ec-input ec-textarea" rows="3" formControlName="address"
                  [placeholder]="'componentsWizard.estabCreate.addressPlaceholder' | translate"></textarea>
      </div>

      <!-- Fuseau -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.estabCreate.timezoneLabel' | translate }}</label>
        <select class="acc-input ec-input" formControlName="tz">
          <option value="Europe/Paris">Europe/Paris (UTC+1/+2)</option>
          <option value="Africa/Casablanca">Africa/Casablanca (UTC+0/+1)</option>
          <option value="America/Guadeloupe">America/Guadeloupe (UTC-4)</option>
          <option value="America/Martinique">America/Martinique (UTC-4)</option>
          <option value="America/Cayenne">America/Cayenne (UTC-3)</option>
          <option value="Indian/Reunion">Indian/Reunion (UTC+4)</option>
          <option value="Indian/Mayotte">Indian/Mayotte (UTC+3)</option>
          <option value="Pacific/Noumea">Pacific/Noumea (UTC+11)</option>
          <option value="Pacific/Tahiti">Pacific/Tahiti (UTC-10)</option>
        </select>
      </div>

      <div class="acc-actions ec-actions">
        <button type="button" class="acc-btn acc-cancel" [disabled]="loading" (click)="onClose()">
          {{ 'componentsWizard.estabCreate.cancel' | translate }}
        </button>
        <button class="acc-btn acc-primary" type="submit" [disabled]="loading || form.invalid">
          {{ (loading ? 'componentsWizard.estabCreate.creating' : 'componentsWizard.estabCreate.create') | translate }}
        </button>
      </div>
    </form>
  </section>
</div>
